import { Component } from '@angular/core';

@Component({
  selector: 'app-ds-filter-bar',
  standalone: false,
  template: `
    <section class="ds-card ds-filter-bar">
      <ng-content></ng-content>
    </section>
  `,
})
export class DsFilterBar {}
